import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { PRINT_MAP } from '../../redux/map/Constants';

import withDrawControlLite from '../../hoc/map/WithDrawControlLite';
import withSiteCards from '../../hoc/map/WithSiteCards';
import StandaloneMap from '../Mapbox/StandaloneMap';

const Map = compose(withSiteCards, withDrawControlLite)(StandaloneMap);

class PrintMap extends React.Component {
    static propTypes = {
        ControlContainer: PropTypes.any,
        baseLayer: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        drawModule: PropTypes.any,
        drawnFeatures: PropTypes.object, // FeatureCollection
        factoryParameters: PropTypes.object,
        activeLayers: PropTypes.array.isRequired,
        events: PropTypes.object,
        layers: PropTypes.array.isRequired,
        // callbacks
        onMapLoaded: PropTypes.func,
        onImageReady: PropTypes.func
    };

    static defaultProps = {
        ControlContainer: null,
        padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        }
    };

    constructor (props) {
        super(props);
        this.state = {
            mapObj: null
        };

        this.handleStyleLoad = this.handleStyleLoad.bind(this);
        this.handleDrawLoaded = this.handleDrawLoaded.bind(this);
        this.mapResized = false;
    }

    handleDrawLoaded () {

    }

    handleStyleLoad (map) {
        const { onMapLoaded, onImageReady, activeLayers, layers } = this.props;
        this.map = map;
        onMapLoaded(this.map);
        // map.on('idle', (e) => {
        //     if (!this.mapResized) {
        //         this.mapResized = true;
        //         map.resize();
        //     } else {
        //         this.mapResized = false;
        //         onImageReady(map.getCanvas().toDataURL('image/png', 1.0), map);
        //     }
        // })
    }

    render () {
        const {
            baseLayer,
            drawnFeatures,
            layers,
            activeLayers,
            drawStyles
        } = this.props;

        const formattedActiveLayers = activeLayers;
        return (
            <Map
                {...this.props}
                id={PRINT_MAP}
                style={baseLayer.styling.mapbox}
                drawnFeatures={drawnFeatures}
                layers={layers}
                activeLayers={formattedActiveLayers}
                onMapLoaded={this.handleStyleLoad}
                onDrawLoaded={this.handleDrawLoaded}
                drawControls={{}}
                drawStyles={drawStyles}
            >
                {this.props.children}
            </Map>
        );
    }
}

export default PrintMap;